import React from 'react';

const BackButton = ({step, setStep}) => {
    if (step === 1) return null;
    return (
        <button
            type="button"
            onClick={() => setStep((s) => Math.max(1, s - 1))}
            className="w-full bg-white/40 text-black/70 border py-2 rounded-lg hover:bg-white/60 transition"
        >
            Назад
        </button>
    );
};

export default BackButton;